import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Badge from '@material-ui/core/Badge';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import stc from 'string-to-color';
import { getInitials, getFullName, toUserTimezone } from 'utils';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'white',
    'position': 'relative',
    'cursor': 'pointer',
    'transition': 'all .2s ease',
    'borderBottom': '1px solid #eee',
    '& :hover': {
      backgroundColor: '#f8f8f8'
    }
  },
  header: {
    overflow: 'hidden',
  },
  linkWrapper: {
    display: 'block',
    textDecoration: 'none',
    color: 'inherit',
  },
  active: {
    backgroundColor: '#E6F3FB',
    borderColor: theme.palette.primary.main,
  },
  avatarGroup: {
    marginLeft: 8,
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  large: {
    width: 46,
    height: 46,
  },
  time: {
    textAlign: 'right',
  },
  message: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  }
}));

const ThreadItem = ({
  convo_id,
  type,
  user,
  users,
  message,
  subject,
  unread,
  updated_at,
  last_message_at
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Link to={`/inbox/${type}/${convo_id}`} className={classes.linkWrapper}>
        <CardHeader
          classes={{
            content: classes.header,
          }}
          avatar={
            <AvatarGroup spacing={'small'} className={classes.avatarGroup}>
              {users.map(({ user }) => (
                <Avatar
                  src={user.avatar}
                  style={{ backgroundColor: stc(user.user_email), width: 34, height: 34 }}
                >
                  {getInitials(user.user_first_name, user.user_last_name)}
                </Avatar>
              ))}
            </AvatarGroup>
          }
          title={subject}
          titleTypographyProps={{
            color: unread ? 'black' : 'textPrimary',
            variant: 'body2',
            style: {
              fontWeight: unread ? 'bolder' : 'normal',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            },
          }}
          subheader={message}
          subheaderTypographyProps={{
            variant: 'caption',
            color: 'textSecondary',
            style: {
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            },
          }}
          action={
            <Typography variant="body2" color="textPrimary">
              {toUserTimezone(last_message_at, user.timezone).format('MMM D, YY, h:mm A')}
            </Typography>
          }
        />
      </Link>
    </Box>
  );
};

export default ThreadItem;
